import styled from '@emotion/styled'

export const OlyLogo = styled.img`
    label: OlyLogo;
    max-height:170px;
`
export const PageDiv = styled.div`
    label: PageDiv;
    /* max-width: 1110px; */
    margin: 0 auto;
`

export const BackgroundDiv = styled.div`
    label: BackgroundDiv;
    background-color: ${(props) => props.theme.backgrounds.backGround1};
    display: flex;
    flex-direction:column;
    align-items:center;
`

export const PageFooterImage = styled.img`
    label: PageFooterImage;
    height:125px;
`